import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/wbst-banner-02.webp")